import { connect } from 'react-redux';

import BoardgamePageComponent from '../components/BoardgamePage';

import { fullBoardgameSelector } from '../reducers/boardgames';
import { isLoadingSelector } from '../reducers';
import {
  loadingSelector as galleryLoadingSelector,
  galleryForBoardgameSelector,
  galleryConfigForBoardgameSelector,
} from '../reducers/galleries';

import { changeHeaderType } from '../actions/navigation';
import { getBoardgame, getGalleryForBoardgame } from '../actions/boardgames';
import { getCategories } from '../actions/categories';
import { withParams } from '../utilities/reactRouter'

const mapStateToProps = (state, ownProps) => {
  return {
    boardgame: fullBoardgameSelector(state)(ownProps.params.id),
    gallery: galleryForBoardgameSelector(state)(ownProps.params.id),
    galleryConfiguration: galleryConfigForBoardgameSelector(state)(ownProps.params.id),
    loading: isLoadingSelector(state),
    loadingGallery: galleryLoadingSelector(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeHeaderType: (type) => dispatch(changeHeaderType(type)),
    getBoardgame: (id) => dispatch(getBoardgame(id, true)),
    getCategories: () => dispatch(getCategories()),
    getGalleryForBoardgame: (id, bggId, page, limit) => dispatch(getGalleryForBoardgame(id, bggId, page, limit)),
  };
};

const BoardgamePage = withParams(
  connect(mapStateToProps, mapDispatchToProps)(BoardgamePageComponent)
);

export default BoardgamePage;
